/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Heading, Icon, Stack } from 'sarsaparilla';
import HolderForm from './HolderForm';
import { RESERVATIONS_ACTION_UPDATE } from '../../constants';

export default function Holders({
    action,
    errors,
    onChangeHandler,
    removeReservationHandler,
    reservations,
}) {
    const hasReservations = !!reservations.length;

    if (!hasReservations) {
        return null;
    }

    const hasRemoveButton = action !== RESERVATIONS_ACTION_UPDATE;

    return (
        <div className="ia-holders">
            <Stack>
                <Heading headingLevel={3} appearance="h5" className="ia-holders-title">
                    Enter Pass Details
                </Heading>
                <div className="ia-holders-description">
                    <p>Please provide the the required information below:</p>
                </div>
                {reservations.map((item, index) => {
                    return (
                        <div className="ia-holders-item" key={`ia-holders-item-${index}`}>
                            <div className="ia-holders-item-header">
                                <Heading
                                    headingLevel={3}
                                    appearance="h6"
                                    className="ia-holders-item-title"
                                >
                                    {item?.pass_type?.name}
                                </Heading>
                                {hasRemoveButton && (
                                    <Button
                                        appearance="link"
                                        className="ia-holders-delete-cta"
                                        onClick={() =>
                                            removeReservationHandler(item?.pass_type?.id)
                                        }
                                        aria-label="Remove"
                                    >
                                        <Icon iconName="delete" />
                                        <span className="ia-holders-delete-cta-text">
                                            Remove
                                        </span>
                                    </Button>
                                )}
                            </div>
                            <div className="ia-holders-item-body">
                                <HolderForm
                                    key={`holder-form-${item?.pass_type?.id}`}
                                    errors={errors[item?.pass_type?.name] || []}
                                    index={index}
                                    onChangeHandler={onChangeHandler}
                                    reservation={item}
                                />
                            </div>
                        </div>
                    );
                })}
            </Stack>
        </div>
    );
}

Holders.propTypes = {
    action: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    removeReservationHandler: PropTypes.func.isRequired,
    reservations: PropTypes.array.isRequired,
};
